<template>
  <colored-icon :color="getStringColor(value)" :icon-class="iconClass" :shadow="shadow"></colored-icon>
</template>

<script>
import ColoredIcon from '@kanrisha/components/Icons/ColoredIcon';

export default {
  components: {
    ColoredIcon,
  },
  props: {
    value: { type: String, default: '' },
    iconClass: { type: String, default: 'bi bi-square-fill' },
    color: { type: String, default: '' },
    shadow: { type: Boolean, default: true },
  },
  setup(props) {
    const getStringColor = () => {
      if (!props.value) {
        return null;
      }

      let localValue = props.value ? props.value + '' : '#000000';

      if (localValue[0] === '#') {
        return localValue.substring(0, 7);
      }

      let length = localValue.length;
      let half = Math.floor(length / 2);
      let colorString =
        localValue.substring(0, 1) + localValue.substring(length - 1, length) + localValue.substring(half, half + 1);
      var colorValues = [];
      for (var n = 0, l = colorString.length; n < l; n++) {
        let colorValue = Math.floor((((colorString.charCodeAt(n) - 65) % 26) / 26) * 255);
        if (colorValue < 0) {
          colorValue = 0;
        }
        var hex = Number(colorValue).toString(16).padStart(2, '0');
        colorValues.push(hex);
      }

      return '#' + colorValues.join('');
    };

    return {
      getStringColor,
    };
  },
};
</script>
